import React from 'react';
import { Link } from 'react-router-dom';
import { FiHeart, FiMail } from 'react-icons/fi';

import adopetLogo from '../../assets/adopet-logo-full.webp';
import bigaLogo from '../../assets/biga-logo.webp';

import {
  BottomBar,
  Brand,
  Container,
  Content,
  Institutional,
  LegalLinks,
} from './styles';

const Footer: React.FC = () => {
  return (
    <Container>
      <div className="neon-line" />

      <Content>
        <Brand>
          <Link to="/" className="brand-link">
            <img src={adopetLogo} alt="AdopetCP" className="adopet-logo" width={720} height={627} />
          </Link>

          <p className="desc">
            Plataforma colaborativa de adoção e suporte animal, conectando
            proteção, cuidado e comunidade em Cornélio Procópio.
          </p>

          <p className="city">Cornélio Procópio • PR</p>

          <a href="mailto:contato@adopetcp.com.br" className="contact-email">
            <FiMail />
            contato@adopetcp.com.br
          </a>

          <LegalLinks>
            <a href="/legal/termos-de-uso.pdf" target="_blank" rel="noreferrer">
              Termos
            </a>

            <a
              href="/legal/politica-de-privacidade.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Privacidade
            </a>

            <a
              href="/legal/politica-de-cookies.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Cookies
            </a>

            <a
              href="/legal/politica-de-moderacao-e-conteudo.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Moderação
            </a>

            <a
              href="/legal/aviso-de-adocao-responsavel.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Adoção responsável
            </a>

            <a
              href="/legal/politica-de-exclusao-de-conta.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Exclusão de conta
            </a>
          </LegalLinks>
        </Brand>

        <Institutional>
          <span className="eyebrow">Desenvolvido por</span>

          <a
            href="https://www.biga.codes"
            target="_blank"
            rel="noreferrer"
            className="biga-link"
          >
            <img
              src={bigaLogo}
              alt="BIGA Software & Systems"
              className="biga-logo"
              width={952}
              height={960}
            />
          </a>

          <div className="company-text">
            <strong>BIGA • Software &amp; Systems</strong>
            <span>
              Felipe Bigarelli Dantas da Costa Desenvolvimento de Software Ltda
            </span>
            <span>CNPJ 62.105.078/0001-28</span>
            <span>Curitiba/PR</span>
            <a href="https://www.biga.codes" target="_blank" rel="noreferrer">
              biga.codes
            </a>
          </div>
        </Institutional>
      </Content>

      <BottomBar>
        <p className="line">
          Feito com <FiHeart /> para os pets de CP
        </p>
        <p className="copy">© 2026 AdopetCP. Todos os direitos reservados.</p>
      </BottomBar>
    </Container>
  );
};

export default Footer;
